import { toast } from 'sonner';
import { buildSocialUrl } from './social-links';

const SESSION_KEY = 'follow-prompt-shown-v1';

export type FollowChannel = 'facebook' | 'instagram' | 'youtube';

export function trackFollowClick(channel: FollowChannel, placement: string) {
  // Hook for future analytics
  if (typeof window !== 'undefined') {
    try {
      // eslint-disable-next-line no-console
      console.log('[follow-click]', { channel, placement });
    } catch {
      /* noop */
    }
  }
}

/**
 * Vis en venlig "følg os"-toast efter en positiv handling.
 * Maks én pr. session.
 */
export function showFollowPrompt(opts?: { message?: string; placement?: string }) {
  if (typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    /* sessionStorage kan fejle i private mode — fortsæt alligevel */
  }

  const placement = opts?.placement ?? 'unknown';
  const message =
    opts?.message ?? 'Tak! Vil du følge med? Vi er kun lige startet — det betyder alt.';

  setTimeout(() => {
    toast(message, {
      duration: 9000,
      action: {
        label: 'Følg på Facebook',
        onClick: () => {
          trackFollowClick('facebook', placement);
          window.open(buildSocialUrl('facebook', `prompt:${placement}`), '_blank', 'noopener,noreferrer');
        },
      },
    });
  }, 600);
}
